import { render, staticRenderFns } from "./UpNextTaskItem.vue?vue&type=template&id=1a7e7c46&scoped=true&"
import script from "./UpNextTaskItem.vue?vue&type=script&lang=js&"
export * from "./UpNextTaskItem.vue?vue&type=script&lang=js&"
import style0 from "./UpNextTaskItem.vue?vue&type=style&index=0&id=1a7e7c46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7e7c46",
  null
  
)

export default component.exports